import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import { Container, AppBar, Box, MenuItem, CardMedia, Button, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Link, useNavigate } from 'react-router-dom';
import { black, white } from '../../getLPTheme';

const logoStyle = {
  width: '50px',
  height: 'auto',
  cursor: 'pointer',
};


export default function MenuBack() {
  const navigate = useNavigate();

  const handleBack = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.history.length > 1) navigate(-1);
    else navigate('/admin'); 
  };

  return (
    <Container sx={{bgcolor: black[1000]}}>
        <AppBar position="fixed" sx={{boxShadow: 0,bgcolor: 'transparent',backgroundImage: 'none',mt: 0,}}>
            <Box sx={{bgcolor: black[1000], display: 'flex',alignItems: 'center', justifyContent: 'flex-start', direction: "row"}}>
              <Box sx={{mt: 1,}}>
                <MenuItem >
                  <Link to={"/admin"} style={{ textDecoration: 'none' }}>
                      <CardMedia  component='img' image='https://club-vip-media.s3.us-east-1.amazonaws.com/landing-page/landing-carousel/logoWorldGolfClubWhite.png' sx={{width: 160, height: 55}}/>
                  </Link>
                </MenuItem>
              </Box>
              <Box sx={{mt: 1, height: 55, display: 'flex',alignItems: 'center', justifyContent: 'flex-start', direction: "row"}}>
                <Button
                  onClick={handleBack}
                  startIcon={<ArrowBackIosNewIcon />}
                  sx={{ color: white[50], textTransform: 'none' }}
                >
                  Volver
                </Button>
              </Box>
            </Box>
        </AppBar>
    </Container>
  );
}
